import { useEffect } from 'react';

import { getCookie, setCookie } from 'js/utils/cookie.util';
import { useQueryObject } from 'js/app/hooks/query/useQueryObject';

const UTM_KEY_COOKIE = 'utmInfo';

export const useSetUTMCookie = () => {
    const {
        utm_source: source = '',
        utm_medium: medium = '',
        utm_campaign: campaign = '',
        utm_term: term = '',
        utm_content: content = ''
    } = useQueryObject();

    useEffect(() => {
        if (!source && !medium && !campaign) {
            return;
        }

        setCookie(
            UTM_KEY_COOKIE,
            new URLSearchParams({
                source,
                medium,
                campaign,
                term,
                content
            }).toString(),
            { expires: 1, path: '/' }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export const getUtmCookie = () => getCookie(UTM_KEY_COOKIE);

export const removeUtmCookie = () => {
    setCookie(UTM_KEY_COOKIE, '', { expires: -1, path: '/' });
};
